module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.containerClass,
    on: {
      "click": function($event) {
        return _vm.onClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "p-hidden-accessible"
  }, [_c('input', _vm._b({
    ref: "input",
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": _vm.checked,
      "value": _vm.value
    },
    on: {
      "focus": function($event) {
        return _vm.onFocus($event)
      },
      "blur": function($event) {
        return _vm.onBlur($event)
      }
    }
  }, 'input', _vm.$attrs, false))]), _vm._v(" "), _c('div', {
    ref: "box",
    class: ['p-radiobutton-box', {
      'p-highlight': _vm.checked,
      'p-disabled': _vm.$attrs.disabled,
      'p-focus': _vm.focused
    }],
    attrs: {
      "role": "radio",
      "aria-checked": _vm.checked
    }
  }, [_c('div', {
    staticClass: "p-radiobutton-icon"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3492f86e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/radiobutton/RadioButton.vue
// module id = 2137
// module chunks = 0